module.exports = __webpack_public_path__ + "static/img/printbg2.e62d0c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/printbg2.png
// module id = po3n
// module chunks = 2